import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import cn from 'classnames';

import LoginForm from '../../../components/common/forms/LoginForm';
import Button from '../../../components/common/ui/Button';
import Input from '../../../components/form/Input';
import { validateEmail } from '../../../utils/helpers';
import SessionExpired from '../SessionExpired';

import styles from '../CodeVerificationForm/styles.module.scss';

const RequestCodeForm = ({
  formHandler,
  error,
  isLoading,
  email,
  recaptchaRef,
}) => {
  const inputRef = useRef(null);
  const [disabled, setDisabled] = useState(true);
  const [searchParams] = useSearchParams();

  let hasDeviceSnInReq = window.location.search.includes('device_sn');
  const title = hasDeviceSnInReq ? 'Hey!' : 'Welcome Back!';
  const description = hasDeviceSnInReq
    ? 'You will need to log into your account to start the activation process.'
    : '';
  const formType = hasDeviceSnInReq ? 'deviceActivation' : '';

  const handleRequestCodeForm = async (e) => {
    e.preventDefault();
    if (!window.Cypress) {
      const prevToken = recaptchaRef.current.getValue();
      if (prevToken) {
        recaptchaRef.current.reset();
      }
      const token = await recaptchaRef.current.executeAsync();
      if (token) {
        formHandler({
          email: e.target.email.value,
          recaptchaToken: token,
        });
      }
    } else {
      formHandler({
        email: e.target.email.value,
      });
    }
  };

  const handleChange = () => {
    setDisabled(!validateEmail(inputRef.current.value) || isLoading);
  };

  useEffect(() => {
    setDisabled(!validateEmail(inputRef.current.value) || isLoading);
  }, [isLoading]);

  useEffect(() => {
    const email = searchParams.get('email');
    if (email && inputRef.current) {
      inputRef.current.value = email;
      handleChange();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  useEffect(() => {
    if (email && inputRef.current) {
      inputRef.current.value = email;
      handleChange();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return (
    <LoginForm
      title={title}
      description={description}
      submitHandle={handleRequestCodeForm}
      type={formType}
    >
      <Input
        required
        type="email"
        name="email"
        placeholder="Email"
        onChange={handleChange}
        innerRef={inputRef}
      ></Input>
      {error && (
        <p className={cn('text-error', styles.codeVerificationRequestError)}>
          {error}
        </p>
      )}
      <Button
        className={styles.codeVerificationLoginButton}
        disabled={disabled}
        type={'submit'}
        isLoading={isLoading}
      >
        <span>Next</span>
      </Button>
      <SessionExpired />
    </LoginForm>
  );
};

export default RequestCodeForm;
